import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalScrollToService {
  public scrollToTableTop(): void {
    this.scrollTo('ng-hot-table-scroll-target', 0);
  }

  public scrollToToursList() {
    this.scrollTo('ng-tours-list', 50);
  }

  private scrollTo(target: string, offset: number): void {
    const element = document.getElementById(target);

    if (!element) {
      return;
    }

    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }
}
